import React from 'react';
import Text from 'Components/Text';
import { PONTOON } from 'constants/boatApplication';
import Button, { buttonColor } from 'Components/Button';
import { STEP_ID } from 'constants/boatApplication';

export default ({cubicCapacity, boatType, isFinalReview, goToStep, boatDetailsRequestInProcess}) => {
  if (!cubicCapacity) return null;

  if (boatDetailsRequestInProcess) return null;

  if (boatType === PONTOON) {
    const tubesKeys = Object.keys(cubicCapacity.tubes);
    if (!tubesKeys.length) return null;

    const tubesNumber = cubicCapacity.hasCenterTube ? 'Three (3)' : 'Two (2)';


    return (
      <section className='scene_section'>
        <header>Hull Calculations Data</header>
        <Text
          mainWrapperClassName='text__wrapper_primary _margin_right_30'
          textClassName='text__text_primary'
          label='Number of Tubes'
          value={tubesNumber}
        />
        <Text
          mainWrapperClassName='text__wrapper_primary'
          textClassName='text__text_primary'
          label='Average of Pontoon Diameter'
          value={cubicCapacity.calculatedPontoonDiameter}
          units=' In.'
          decimalDigits={2}
        />
        <Text
          mainWrapperClassName='text__wrapper_primary _margin_right_30'
          textClassName='text__text_primary'
          label='Average of Total Pontoon Length'
          value={cubicCapacity.calculatedPontoonLength}
          units=' In.'
          decimalDigits={2}
        />
        <Text
          mainWrapperClassName='text__wrapper_primary'
          textClassName='text__text_primary'
          label='Total Volume of All Tubes'
          value={cubicCapacity.calculatedTubesVolume}
          units=' Cu. Ft.'
          decimalDigits={2}
        />
        {isFinalReview && (
          <Button
            color={buttonColor.planeOrange}
            label='Edit'
            buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
            fontSize={14}
            onClick={() => goToStep(STEP_ID.CUBIC_CAPACITY, true)}
          />
        )}
      </section>
    );
  } else {
    if (cubicCapacity.cubicCapacity === undefined) return null;

    return (
      <section className='scene_section'>
        <header>Cubic Capacity Data</header>
        <Text
          mainWrapperClassName='text__wrapper_primary _margin_right_30'
          textClassName='text__text_primary'
          label='Calculated Cubic Capacity'
          value={cubicCapacity.cubicCapacity}
          units=' Cu. Ft.'
          decimalDigits={2}
        />
        {isFinalReview && (
          <Button
            color={buttonColor.planeOrange}
            label='Edit'
            buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
            fontSize={14}
            onClick={() => goToStep(STEP_ID.CUBIC_CAPACITY, true)}
          />
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/CubicCapacity.jsx